// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 784) return "static/chunks/784-baa1ebb9fd9df4bc.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"57c6946d2e03d57b","298":"3c17f9a45cf5b456","340":"7107c56a5e662d71","367":"33dba68d5bfbd60e","639":"662b2e7c337118a6","748":"ea3392f98cb549fd"}[chunkId] + ".js";
};